import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  loginFailed,
  loginStart,
  loginSuccess,
} from "../../store/slices/userSlice";
import { getUserTenants, loginApi } from "../../service/login/loginService";
import pic from "../../images/login.png";
import { useEffect, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { setLogin } from "../../store/slices/loginSlice";
import logo from "../../images/epms_logo_main.png";
import { getCurrentUserLoginInfo } from "../../service/user/userService";
import { Button } from "primereact/button";
import "../../css/components/login.css";
import { Themes } from "../../data/Themes";
import { ThemeState } from "../../dtos/common/ThemeState";
import { ProgressSpinner } from "primereact/progressspinner";
import { setError } from "../../store/slices/errorSlice";
import { setPermissions } from "../../store/slices/permissionSlice";
import { ListBox } from "primereact/listbox";
export const LoginForm = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const toast = useRef<any>(null);
  const [emailLengthError, setEmailLengthError] = useState("");
  const [pwdLengthError, setPwdLengthError] = useState("");
  const [disableBtn, setDisableBtn] = useState(false);
  const themeName = useSelector((state: ThemeState) => state.theme.themeName);
  const ThemeColors = Themes.find((th) => th.name === themeName);
  const [eyeIcon, setEyeIcon] = useState<string>("pi pi-eye-slash");
  const [passwordType, setPasswordType] = useState("password");
  const inputRef = useRef<any>(null);
  const [tenants, setTenants] = useState<any[]>([]);
  const [showTenantPicker, setShowTenantPicker] = useState(false);
  const [pendingCredentials, setPendingCredentials] = useState<any>(null);

  const handleSettingsVal = (input: any[]) => {
    const keys = ["Language", "Mode", "Theme"];
    keys.forEach((val) => {
      const findVal = input.find((k) => val.includes(k.Key));
      localStorage.setItem(findVal.Key, findVal.Value);
    });
  };

  // const handleClick = async () => {
  //   setDisableBtn(true);
  //   let err: string = "";
  //   if (!tenant || !tenant?.trim()) {
  //     showToast(
  //       "error",
  //       "Tenancy name is required!",
  //       "Error!"
  //     );

  //     err = "error";
  //   }

  //   if (email.length === 0 && password.length === 0) {
  //     setPwdLengthError("Password field is required");
  //     setEmailLengthError("Email field is required");
  //     err = "error";
  //   }

  //   if (email.length === 0) {
  //     setEmailLengthError("Email field is required");
  //     err = "error";
  //     // return;
  //   }
  //   if (password.length === 0) {
  //     setPwdLengthError("Password field is required");
  //     err = "error";
  //     // return;
  //   }
  //   if (email.length > 0 && email.replace(/\s/g, "").length == 0) {
  //     setEmailLengthError("Please enter a valid input");
  //     err = "error";
  //   }
  //   if (password.length > 0 && password.replace(/\s/g, "").length == 0) {
  //     setPwdLengthError("Please enter a valid input");
  //     err = "error";
  //   }



  //   if (err.length === 0) {
  //     setEmailLengthError("");
  //     setPwdLengthError("");

  //     const credentials = {
  //       Email: email,
  //       Password: password,
  //       ...(tenant && tenant?.trim()?.length > 0 ? { tenancyName: tenant?.trim() } : {})
  //     };
  //     try {
  //       dispatch(
  //         setError({
  //           isError: false,
  //           errorMessage: "",
  //         })
  //       );
  //       dispatch(loginStart(credentials));
  //       //login api
  //       const res: any = await loginApi(credentials);
  //       if (res.data.Result !== null) {
  //         //set token in local storage
  //         localStorage.setItem(
  //           "token",
  //           res?.data?.Result?.AuthenticateResult?.Token
  //         );

  //         const userDetails = {
  //           Email: res.data.Result.UserDetails.Email,
  //         };

  //         dispatch(loginSuccess(userDetails));
  //         dispatch(setPermissions(res?.data?.Result?.Permissions))
  //         //set the role and exp time in local storage
  //         localStorage.setItem(
  //           "TokenExpTime",
  //           res.data.Result.AuthenticateResult.ExpTimeInHour
  //         );

  //         //set settings to local storage
  //         if (res.data.Result.Settings.length > 0) {
  //           handleSettingsVal(res.data.Result.Settings);
  //         }

  //         //get logged in user role
  //         const getRoleOfLoggedInUSer = await getCurrentUserLoginInfo(dispatch);

  //         // localStorage.setItem('role', getRoleOfLoggedInUSer?.role);

  //         dispatch(setLogin({ islogin: true }));
  //         if (res?.data?.Result?.Permissions.length === 0) {
  //           return navigate('/permissionDenied')
  //         }

  //         navigate("/dashboard");
  //         // window.location.reload();
  //       }
  //       if (res.data.Result === null) {
  //         toast.current.show({
  //           severity: "error",
  //           summary: "Error",
  //           detail: res.data.Error,
  //           life: 3000,
  //         });
  //       }
  //     } catch (error: any) {
  //       dispatch(loginFailed(error));
  //       toast.current.show({
  //         severity: "error",
  //         summary: "Error",
  //         detail: error?.response?.data.Error,
  //         life: 3000,
  //       });
  //     }
  //   }
  //   setDisableBtn(false);
  // };
  const handleLoginWithTenant = async (credentials: any, selectedTenant: any) => {
    try {
      dispatch(loginStart(credentials));

      const loginPayload = {
        Email: credentials.userNameOrEmailAddress,
        Password: credentials.password,
        tenancyName: selectedTenant?.tenancyName ?? selectedTenant?.name, // adjust key to match your DTO
      };

      const res: any = await loginApi(loginPayload);

      if (res?.data?.Result !== null) {
        localStorage.setItem("token", res.data.Result.AuthenticateResult.Token);
        localStorage.setItem("TokenExpTime", res.data.Result.AuthenticateResult.ExpTimeInHour);
        localStorage.setItem("tenantId", selectedTenant?.id?.toString() ?? "");

        const userDetails = { Email: res.data.Result.UserDetails.Email };
        dispatch(loginSuccess(userDetails));
        dispatch(setPermissions(res.data.Result.Permissions));

        if (res.data.Result.Settings?.length > 0) {
          handleSettingsVal(res.data.Result.Settings);
        }

        await getCurrentUserLoginInfo(dispatch);
        dispatch(setLogin({ islogin: true }));

        if (res.data.Result.Permissions.length === 0) return navigate("/permissionDenied");
        navigate("/dashboard");
      } else {
        toast.current.show({ severity: "error", summary: "Error", detail: res.data.Error, life: 3000 });
      }
    } catch (error: any) {
      dispatch(loginFailed(error));
      toast.current.show({ severity: "error", summary: "Error", detail: error?.response?.data?.Error, life: 3000 });
    }
    finally{
      setShowTenantPicker(false)
    }
  };


  const handleClick = async () => {
    setDisableBtn(true);
    let err = "";

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (email.length === 0) { setEmailLengthError("Email field is required"); err = "error"; }
    if (password.length === 0) { setPwdLengthError("Password field is required"); err = "error"; }
    if (email.length > 0 && email.replace(/\s/g, "").length === 0) { setEmailLengthError("Please enter a valid input"); err = "error"; }
    if (password.length > 0 && password.replace(/\s/g, "").length === 0) { setPwdLengthError("Please enter a valid input"); err = "error"; }
    if (email.length > 0 && email.replace(/\s/g, "").length > 0 && !emailRegex.test(email.trim())) { setEmailLengthError("Please enter a valid email address"); err = "error"; }

    if (err.length > 0) { setDisableBtn(false); return; }

    setEmailLengthError("");
    setPwdLengthError("");

    const credentials = { userNameOrEmailAddress: email, password };

    try {
      dispatch(setError({ isError: false, errorMessage: "" }));

      const res: any = await getUserTenants(credentials);
      const tenantList: any[] = res?.data?.Result ?? [];

      if (tenantList.length === 0) {
        toast.current.show({ severity: "error", summary: "Error", detail: "No tenants found for this account.", life: 3000 });
        setDisableBtn(false);
        return;
      }

      if (tenantList.length === 1) {
        // Auto-select the only tenant and login immediately
        await handleLoginWithTenant(credentials, tenantList[0]);
      } else {
        // More than one tenant – let the user pick
        setPendingCredentials(credentials);
        setTenants(tenantList);
        setShowTenantPicker(true);
      }
    } catch (error: any) {
      dispatch(loginFailed(error));
      toast.current.show({ severity: "error", summary: "Error", detail: error?.response?.data?.Error, life: 3000 });
    }

    setDisableBtn(false);
  };
  const handleToggle = () => {
    if (passwordType === "password") {
      setPasswordType("text");
      setEyeIcon("pi pi-eye");
    } else {
      setPasswordType("password");
      setEyeIcon("pi pi-eye-slash");
    }
  };
  const handleEnterKey = (event: any) => {
    if (event.key === "Enter") {
      handleClick();
    }
  };

  useEffect(() => {
    inputRef.current.focus();
  }, []);

  return (
    <div className="login">
      <span className="login-loading-bar">
        {disableBtn && <ProgressSpinner />}
      </span>
      <Toast ref={toast} />
      <div className="left-login">
        <div className="text-on-image-1">
          <img src={logo} alt="logo" className="login-logo" />
        </div>
        <div className="text-on-image-2">
          <span>Efficiently</span> Monitor Employee <span>Performance</span>
        </div>
        <img src={pic} className="login-image" />
      </div>
      <div className="right-login">
        {!showTenantPicker &&<div className="login-inputs">
          {/* {tenantSelector} */}
          <h2 className="sign-in-text">Sign In</h2>
          <div className="login-inputs-form">
            <div>
              <input
                type="text"
                ref={inputRef}
                autoFocus
                onKeyDown={handleEnterKey}
                className="login-input"
                placeholder="Email Address"
                onChange={(e) => {
                  setEmail(e.target.value);
                  setEmailLengthError(""); // Reset email length error when the user starts typing
                }}
                required
              />
              {emailLengthError && (
                <span className="err-msg">{emailLengthError}</span>
              )}
            </div>
            <div className="password-box">
              <input
                type={passwordType}
                onKeyDown={handleEnterKey}
                className="login-input"
                placeholder="Enter Password"
                onChange={(e) => {
                  setPassword(e.target.value);
                  setPwdLengthError("");
                }}
                required
              />
              <span>
                <i
                  className={eyeIcon}
                  style={{ fontSize: "1.2rem" }}
                  onClick={handleToggle}
                ></i>
              </span>
              {pwdLengthError && (
                <span className="err-msg">{pwdLengthError}</span>
              )}
            </div>
            <Button
              className="login-btn"
              label="Sign In"
              onClick={handleClick}
              disabled={disableBtn}
              style={{
                backgroundColor: ThemeColors?.primaryColor,
                border: "none",
              }}
            />
          </div>
        </div>}
        {/* ── TENANT PICKER ── shown instead of form */}
        {showTenantPicker && (
          <div className="tenant-picker">
            <p className="tenant-picker__label">ACCOUNT FOUND</p>

            <h2 className="tenant-picker__title">
              Choose Your Workspace
            </h2>

            <p className="tenant-picker__subtitle">
              Select the personal or team workspace you want to open.
            </p>

            <ListBox
              value={null}
              options={tenants}
              optionLabel="tenancyName"
              className="w-full"
              listStyle={{
                maxHeight: '300px',
                overflowY: 'auto',
              }}
              itemTemplate={(option) => (
                <div>
                  <div style={{ display: "flex", alignItems: "center", gap: "0.85rem" }}>
                    <div className="tenant-picker__icon">
                      <i className="pi pi-users" />
                    </div>

                    <span className="tenant-picker__name">
                      {option.tenancyName ?? option.name}
                    </span>
                  </div>

                  <i className="pi pi-arrow-right tenant-picker__arrow" />
                </div>
              )}
              onChange={async (e) => {
                setDisableBtn(true);

                await handleLoginWithTenant(
                  pendingCredentials,
                  e.value
                );

                setDisableBtn(false);
              }}
            />

            <Button
              type="button"
              label="Back to Sign In"
              icon="pi pi-arrow-left"
              className="p-button-text mt-3"
              onClick={() => {
                setPendingCredentials(null);
                setTenants([]);
                setShowTenantPicker(false);
              }}
            />
          </div>
        )}
      </div>
      {/* {tenantDialog} */}
    </div>
  );
};
